import { type Ref, ref } from 'vue'
import moment, { type Moment } from 'moment'

const scheduleFocusDate = ref(moment()) as Ref<Moment>
const scheduleSelectedDate = ref<Moment>(moment()) as Ref<Moment>

export { scheduleFocusDate, scheduleSelectedDate }
